import { styled } from "@mui/material/styles";
import Typography from "../../ontego-ui/components/Typography";
import { ColorSAP } from "../../ontego-ui";

export const RootContainer = styled("div")(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
}));

export const VideoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "100%",
  width: "100%",
  [theme.breakpoints.only("sm")]: {
    height: "320px",
  },
}));

export const PlayButton = styled("div")(({ theme }) => ({
  padding: 24,
  width: 56,
  height: 56,
  borderRadius: 240,
  backgroundColor: ColorSAP.primary[70],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  [theme.breakpoints.up("md")]: {
    width: 80,
    height: 80,
  },
}));

export const VideoThumbnailContainer = styled("div")(() => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  zIndex: -1,
  overflow: 'hidden'
}));

export const VideoThumbnail = styled("video")(() => ({
  height: '100%',
  width: '100%',
  objectFit: 'cover'
}));

export const LoginContainer = styled("div")(({ theme }) => ({
  boxSizing: "border-box",
  maxHeight: "100%",
  padding: "0px 24px 24px 24px",
  height: "100%",
  [theme.breakpoints.only("sm")]: {
    maxWidth: "539px",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "48px 48px 0px 48px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "64px 90px 64px 120px",
  },
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
}));

export const FooterContainer = styled("div")(({ theme }) => ({
  display: "flex",
  margin: "0px 24px 64px 24px",
  marginTop: 44,
  [theme.breakpoints.up("sm")]: {
    marginTop: 47,
    margin: "0px 48px 48px 48px",
  },
  [theme.breakpoints.up("md")]: {
    marginTop: 65,
    margin: "0px 90px 64px 120px",
  },
}));

export const LinkRegister = styled(Typography)(({ theme }) => ({
  letterSpacing: "unset",
  lineHeight: "20px",
  [theme.breakpoints.up("sm")]: {
    lineHeight: "22px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 16,
  lineHeight: "42px",
  [theme.breakpoints.up("sm")]: {
    marginBottom: 24,
    lineHeight: "80px",
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  marginBottom: 20,
  lineHeight: "20px",
  letterSpacing: "unset",
  [theme.breakpoints.up("sm")]: {
    lineHeight: "22px",
    marginBottom: 21,
  },
  [theme.breakpoints.up("md")]: {
    lineHeight: "20px",
    marginRight: 25,
    marginBottom: 24,
  },
}));
